import React from "react";
import { Outlet } from "react-router-dom";
import ScrollToTop from "../Components/ScrollTop";

const AuthLayOut = () => {
  return (
    <>
      <ScrollToTop />
      <Outlet />
    </>
  );
};

export default AuthLayOut;
